import Divider from "../Divider/Divider";
import { Link } from "react-router-dom";
import Logo from "../../assets/GiftLoopWordmarkLight.svg";

export default function Footer() {
    return (
        <footer className="bg-surface py-6 mt-8">
            <div className="max-w-6xl mx-auto flex flex-col items-center text-center space-y-3 px-4">
                {/* Logo */}
                <Link to="/">
                    <img src={Logo} alt="GiftLoop Logo" className="h-8 w-auto" />
                </Link>

                {/* Divider */}
                <div className="w-full">
                    <Divider />
                </div>

                {/* Footer Links */}
                <ul className="flex flex-wrap justify-center gap-8">
                    <li>
                        <Link
                            to="/about"
                            className="text-text hover:text-primary font-bold text-sm uppercase transition-colors duration-200 tracking-wide"
                        >
                            About
                        </Link>
                    </li>
                    <li>
                        <Link
                            to="/contact"
                            className="text-text hover:text-primary font-bold text-sm uppercase transition-colors duration-200 tracking-wide"
                        >
                            Contact
                        </Link>
                    </li>
                    <li>
                        <Link
                            to="/privacy"
                            className="text-text hover:text-primary font-bold text-sm uppercase transition-colors duration-200 tracking-wide"
                        >
                            Privacy
                        </Link>
                    </li>
                    <li>
                        <Link
                            to="/terms"
                            className="text-text hover:text-primary font-bold text-sm uppercase transition-colors duration-200 tracking-wide"
                        >
                            Terms
                        </Link>
                    </li>
                </ul>
            </div>
        </footer>
    );
}
